import ApiResourceManager from '../ApiResourceManager';
import ReduxHooks from '../../../store/ReduxHooks';
import { actionCreators } from '../../../store/actions';

export default class StorefrontManager extends ApiResourceManager {
  create = async (data) => {
    const response = await this.request({
      method: 'POST',
      url: '/storefront',
      data,
    });

    if (response.success) {
      // The skipped-reservations report is for the screen that created the website,
      // not for the store: `currentCompany.set` replaces the persisted company whole.
      const { reservations_skipped: _reservationsSkipped, ...company } = response.data ?? {};

      ReduxHooks.dispatch(actionCreators.currentCompany.set(company));
    }

    return response;
  };

  get = async () =>
    this.request({
      method: 'GET',
      url: '/storefront',
    });

  delete = async () =>
    this.request({
      method: 'DELETE',
      url: '/storefront',
    });

  toggleReservations = async (data) =>
    this.request({
      method: 'POST',
      url: '/storefront/toggle-reservations',
      data,
    });

  syncCompany = (id) =>
    this.request({
      method: 'POST',
      url: `/storefront/companies/${id}/sync`,
    });

  getStats = (params) =>
    this.request({
      method: 'GET',
      url: '/storefront/stats',
      params,
    });

  transfer = (data) =>
    this.request({
      method: 'POST',
      url: '/transfer-storefront',
      data,
    });
}
